<template>
  <div class="app">
    <div id="appHeader">
      <div :class="$route.meta.authBackground || checkAppRoute() ? 'app-auth-sticky' : 'app-sticky'"
        :style="$commonMethod.customAppHeader(2, 0)">
        <van-nav-bar :title="$route.meta.title"
          :left-arrow="$route.path == getAppRoute() || $route.meta.leftBtnHide ? false : true"
          @click-left="onClickLeft">
          <template #right>
            <van-popover v-model="showPopover" theme="dark" trigger="click" placement="bottom-end" :overlay="true"
              v-if="$route.meta.rightBtnShow" :actions="actions" @select="onSelectPopover">
              <template #reference>
                <div class="moreButton">
                  <van-image class="iconImg" :src="moreIcon"></van-image>
                </div>
              </template>
            </van-popover>
          </template>
        </van-nav-bar>
      </div>
    </div>
    <div id="appContent">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
    <footer>
      <van-tabbar v-show="$route.meta.footerShow" v-model="active" active-color="#2c2c2c" inactive-color="#c6c6c6"
        safe-area-inset-bottom :class="platform == 'ios' ? 'ios-footer' : 'android-footer'">
        <van-tabbar-item v-for="(item, index) in tabbars" :key="index" :to="item.path"
          @click="onChange(index, item.path, item.name)">
          <span>{{ item.title }}</span>
          <template slot="icon" slot-scope="props">
            <img :src="props.active ? item.active : item.normal" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </footer>

    <radio-list :title="$t.meta.systemLanguage" event="showHomeLanguages" :value="Language" :options="langOptions"
      @onSelect="onSelectLanguage"></radio-list>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Grid,
  GridItem,
  Icon,
  Image,
  Button,
  Tabbar,
  TabbarItem,
  NavBar,
  NoticeBar,
  Popover
} from "vant";
import { getRoute, getPlatform, isHuaweiDevice } from "@/plugins/environment/type.js";
import RadioList from "@components/radioList/RadioList.vue";

Vue.use(Grid).use(GridItem).use(Icon).use(Image).use(Button).use(Tabbar).use(TabbarItem).use(NavBar).use(NoticeBar).use(Popover);
export default {
  name: "App",
  components: {
    RadioList
  },
  data() {
    return {
      Language: localStorage.getItem("language") || "auto",
      platform: getPlatform(),
      isHuaweiDevice: isHuaweiDevice(),
      active: 0,
      route: "app",
      tabbars: [
        {
          path: getRoute() + "home",
          name: "Home",
          title: this.$t.meta.homePage,
          normal: require("@/assets/img/home/home.png"),
          active: require("@/assets/img/home/home_fill.png"),
        },
        {
          path: getRoute() + "user/userManage",
          name: "User",
          title: this.$t.meta.userPage,
          normal: require("@/assets/img/home/my.png"),
          active: require("@/assets/img/home/my_fill.png"),
        },
      ],
      //更多
      langOptions: [],
      showPopover: false,
      actions: [],
      moreIcon: require("@/assets/img/home/more.png"),
    };
  },
  watch: {
    $route(to, from) {
      this.setActions();
      setTimeout(() => {
        this.setContentClasses(to.meta.stickyHeader);
      });
    },
  },
  methods: {
    setActions() {
      if (this.isHuaweiDevice) {
        this.actions = [{ id: 2, text: this.$t.meta.popover2, icon: "font-o" }];
      } else {
        this.actions = [
          { id: 1, text: this.$t.meta.popover1, icon: "scan" },
          { id: 2, text: this.$t.meta.popover2, icon: "font-o" },
        ];
      }
    },
    onSelectPopover(action) {
      if (action.id == 1) {
        this.onScan();
      }
      if (action.id == 2) {
        this.onShowEmit("showHomeLanguages");
      }
    },
    onScan() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.scan, {
        options: {
          baseColor: "#009ed4",
          choosePhotoEnable: "true",
          flashlightEnable: "true",
          title: this.$t.meta.scanTitle,
          describe: this.$t.meta.scanDes,
          choosePhotoBtnTitle: this.$t.meta.scanButton,
        },
        errorText: this.$t.meta.scanError1,
        authText: this.$t.meta.scanError2,
      });
    },
    onShowEmit(emit) {
      this.langOptions = [
        { text: this.$t.meta.autoLanguage, value: "auto" },
        { text: "中文", value: "zh" },
        { text: "English", value: "en" },
        { text: "العربية", value: "ar" },
      ];
      this.$bus.$emit(emit, true);
    },
    onSelectLanguage(value) {
      localStorage.setItem("language", value);
      this.$commonEnv.commonAction(this.$commonEnv.actionType.refresh);
    },
    setContentClasses(isSticky) {
      const element = document.getElementById("appContent");
      var classes = [];
      if (isSticky) {
        if (this.platform == "ios") {
          classes.push("ios-content");
        }
        if (this.platform == "android") {
          classes.push("android-content");
        }
      }
      var isAuth = this.$route.path.includes("auth");
      var isNotApp = this.$route.path == "/" + this.route;
      if (isAuth || isNotApp) {
        classes.push("none-bottom");
      } else {
        classes.push("mb-bottom");
      }
      element.className = classes.join(" ");
    },
    onChange(index) {
      this.active = index;
      if (this.active == index) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    onClickLeft() {
      if (this.$route.meta.backUser) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.backUser);
      } else if (this.$route.meta.backHome) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.backHome);
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
      }
    },
    getAppRoute() {
      return '/' + this.route + '/'
    },
    checkAppRoute() {
      if (this.$route.path == '/' + this.route + '/') {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.active = 0;
    this.route = getRoute(true);
  },
  updated() {
    if (this.$route.path.includes("home")) {
      this.active = 0;
    } else if (this.$route.path.includes("user")) {
      this.active = 1;
    } else {
      this.active = 0;
    }
  },
};
</script>
<style></style>
<style lang="scss" scoped>
.app {
  $-headerhight: 50px;
  $-backgroundColor1: linear-gradient(left, #009ed4, #5029c3);
  $-backgroundColor2: linear-gradient(left, #009ed4, #2c8ed2);

  #appHeader {

    // 默认页头
    .app-sticky {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      background: $-backgroundColor1;
    }

    // 登录专属页头
    .app-auth-sticky {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      background: $-backgroundColor2 !important;

      ::v-deep .van-nav-bar {
        background: $-backgroundColor2 !important;

        .van-nav-bar__title {
          color: transparent !important;
        }
      }
    }

    ::v-deep .van-nav-bar {
      background: $-backgroundColor1;
      line-height: $-headerhight;
      height: $-headerhight;

      .van-nav-bar__content {
        line-height: $-headerhight;
        height: $-headerhight;

        .van-nav-bar__arrow {
          color: #fff;
          font-size: 2rem;
        }

        .van-nav-bar__title {
          color: #fff;
          font-size: 1.2rem;
        }
      }
    }

    .van-hairline--bottom::after {
      display: none;
    }
  }

  .moreButton {
    margin-bottom: 2px;

    .iconImg {
      width: 20px;
      height: 20px;
      object-fit: contain;
      vertical-align: middle;
    }
  }

  header img {
    width: 0.66rem;
    height: 0.57rem;
    vertical-align: middle;
  }

  footer {
    height: auto;
    line-height: 1rem;
    color: #fff;
  }

  footer img {
    width: 1.5rem;
    height: 1.5rem;
  }

  footer ::v-deep .ios-footer {
    height: auto;
    color: #999;
    z-index: 100 !important;
    padding-top: 5px;
    padding-bottom: calc(5px + env(safe-area-inset-bottom));
  }

  footer ::v-deep .android-footer {
    height: auto;
    color: #999;
    z-index: 100 !important;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .ios-content {
    margin-top: calc($-headerhight + env(safe-area-inset-top));
  }

  .android-content {
    margin-top: $-headerhight;
  }

  .none-bottom {
    margin-bottom: 0vw;
  }

  .mb-bottom {
    margin-bottom: 30vw;
  }
}
</style>
